module.exports = __webpack_public_path__ + "static/media/4.11a77f14.png";